import React, { useState, useEffect } from 'react';

import "./index.scss";

const SNSPanel = ({ ...props }) => {
    const [isHidden, setIsHidden] = useState(false);

    useEffect(() => {
        const hideIfIsInsideBanner = () => {
            const banner = document.querySelector(".js-banner");
            if (!banner) {
                setIsHidden(false);
                return;
            }
            const bannerRect = banner.getBoundingClientRect();
            const bannerBottom = bannerRect.top + bannerRect.height;

            // hide panel if is inside banner
            if (window.scrollY <= (bannerBottom / 2)) {
                setIsHidden(true);
            } else {
                setIsHidden(false);
            }
        }

        hideIfIsInsideBanner();

        window.addEventListener("scroll", hideIfIsInsideBanner);

        return () => {
            window.removeEventListener("scroll", hideIfIsInsideBanner);
        }

    }, [])

    return (
        <div className={`sns-panel ${isHidden ? "is--hidden" : ""}`}>
            <a href="https://line.me/R/ti/p/@297nihqk" target="_blank" rel="noopener noreferrer">
                <img src="/images/icon-line.png" />
            </a>
            <a href="https://www.facebook.com/messages/t/400784643314232" target="_blank" rel="noopener noreferrer">
                <img src="/images/icon-messenger.png" />
            </a>
        </div>
    )
}

export default SNSPanel;